import { render, staticRenderFns } from "./IndexVoucher.vue?vue&type=template&id=2dbd90f6&"
import script from "./IndexVoucher.vue?vue&type=script&lang=js&"
export * from "./IndexVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports